import cx from "classnames";
import styles from "./HeaderNoteImage.module.css";
import LazyLoad from "react-lazy-load";
import Image from "next/image";
import React from "react";

const HeaderNoteImage = ({ title, src }) => {
    return (
        <div
            className={cx(
                styles.mainImageContainer,
                "d-flex",
                "align-items-center",
                "justify-content-cetner",
                "w-100"
            )}
        >
            <LazyLoad offset={100}>
                <Image
                    priority={true}
                    unoptimized
                    alt={title}
                    src={src}
                    width={100}
                    height={100}
                    className={cx(styles.mainImageContainerImg)}
                ></Image>
            </LazyLoad>
        </div>
    );
};

export default HeaderNoteImage;